import http from "../http-common";

class TripDataService {
  getAll() {
    return http.get("/trips");
  }

  get(id) {
    return http.get(`/trips/id/${id}`);
  }

  update(id, data) {
    return http.put(`/trips/id/${id}`, data);
  }

  createTrip(data) {
    return http.post("/trips", data);
  }

  delete(id, deletedBy = 1) {
    return http.delete(`/trips/id/${id}`, {
      data: { deletedBy }
    });
  }

  deleteGroup(groupId, deletedBy = 1) {
    return http.delete(`/trips/group/${groupId}`, {
      data: { deletedBy }
    });
  }

  removeClientFromGroup(groupId, tripClientId, selectedDate, deletedBy = 1) {
    return http.delete(`/trips/group/${groupId}/tripClient/${tripClientId}/selectedDate/${selectedDate}`, {
      data: { deletedBy }
    });
  }

  createGroup(groupData) {
    return http.post(`/trips/group`, groupData);
  }

  updateGroupGuides(groupId, guideId, guideAdditionalId, tripDate) {
    return http.put(`/trips/group/${groupId}/guide`, {
      guideId,
      guideAdditionalId,
      tripDate
    });
  }

  updateGroupDate({ groupId, tripId, newEndDate }) {
    return http.put(`/trips/groupDate/${tripId}/${groupId}`, { end_date: newEndDate });
  }

  continueTripTill({ groupId, tripId, newEndDate }) {
    return http.put(`/trips/continueTill/${tripId}/${groupId}`, { end_date: newEndDate });
  }

  copyTripToDate({ tripId, targetDate, groupId, conflictResolution }) {
    return http.post(`/trips/copyToDate/${tripId}`, {
      target_date: targetDate,
      groupId: groupId,
      conflict_resolution: conflictResolution
    });
  }

  fetchGuides() {
    return http.get("/staff/job/2");
  }

  fetchGuidesForTripGroup(tripId, groupId) {
    return http.get(`/trips/guides/${tripId}/${groupId}`);
  }

  fetchPilots() {
    return http.get("/staff/job/1");
  }

  fetchPilotsForTrip(tripId) {
    return http.get(`/trips/pilots/${tripId}`);
  }

  fetchHelicopters() {
    return http.get("/trips/helicopters");
  }

  fetchHelicoptersForTrip(tripId) {
    return http.get(`/trips/helicopters/${tripId}`);
  }

  fetchTripsByDate(date) {
    return http.get(`/trips/date/${date}`);
  }

  fetchGroupsForTrip(tripId, selectedDate) {
    return http.get(`/trips/findgroups/${tripId}`, {
      params: { selectedDate },
    });
  }

  findByGuideAndDate(staffId, date) {
    return http.get(`/trips/findByGuideAndDate/${staffId}/${date}`);
  }

  assignReservationToTripGroup(data) {
    return http.post('/trips/assign', data);
  }

  removeReservationFromTrip(tripId, reservationId, selectedDate) {
    const data = {
      tripId: tripId,
      reservationId: reservationId,
      selectedDate: selectedDate
    };
    return http.post('/trips/removereservation', data);
  }

  updateTraining(data) {
    return http.post("/trips/updateTraining", data);
  }

  getTripGroupFuelPercentage(tripGroupId, selectedDate) {
    return http.get(`/trips/group/${tripGroupId}/fuelPercentage`, {
      params: { selectedDate },
    });
  }
}

export default new TripDataService();
